/* eslint-disable no-underscore-dangle, react/destructuring-assignment, react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import { Button, Card, CardBody, CardHeader, Collapse } from "reactstrap";
import __ from "src/utils/Translations";
import PerkUsersDataTable from "./table";

export default function PerkUsersListing() {
  return (
    <>
      <PerkUsersDataTable />
    </>
  );
}
